import * as React from 'react';
import { getConfigurationFromWindowOrDefault } from './CitrixUIInternal';
import { CitrixUIContext } from './Context';
export var useCitrixUIContext = function useCitrixUIContext() {
  var existingContext = React.useContext(CitrixUIContext);
  var windowContext = getConfigurationFromWindowOrDefault();
  return existingContext || windowContext;
};